import React from 'react';
import { KFS_CONSTANTS } from '../types/kfs.types';
import { formatDate } from 'utils/lmmsHelpers';
import IconSystem from 'icon-collection/icon-systems';

interface KfsInstalmentTableProps {
  dates: Date[] | null;
}

const QUARTERS = [
  { label: 'Q1', color: 'blue' },
  { label: 'Q2', color: 'green' },
  { label: 'Q3', color: 'amber' },
  { label: 'Q4', color: 'purple' },
];

const KfsInstalmentTable: React.FC<KfsInstalmentTableProps> = ({ dates }) => {
  return (
    <div className="kfs-card">
      <div className="kfs-card-header">
        <div className="kfs-card-header-icon purple">
          <IconSystem.calendar size={16} />
        </div>
        <h3>Instalment Due Dates</h3>
        <span>Quarterly</span>
      </div>
      <div className="kfs-card-body">
        <div className="kfs-instalment-grid">
          {QUARTERS.map((q, idx) => (
            <div className={`kfs-instalment-card ${q.color}`} key={q.label}>
              <div className="kfs-instalment-label">{q.label}</div>
              <div className="kfs-instalment-date">
                {dates ? formatDate(dates[idx]) : '--/--/----'}
              </div>
              <div className="kfs-instalment-formula">
                + {KFS_CONSTANTS.INSTALMENT_INTERVALS[idx]} days
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KfsInstalmentTable;
